import { DateTime } from 'luxon';
import api from './Api';
import { getStoredLanguage } from '../utils/Language';
import { UnavailableDaysPreview } from '../interfaces/UnavailableDays';

export const parseUnavailableDays = async (
  departmentSectionID: number,
  personnelIDs: number[],
  startAt: Date,
  endAt: Date,
  prompt: string,
  imageDataUrl: string | undefined,
  signal: AbortSignal,
): Promise<UnavailableDaysPreview> => {
  const response = await api.post(
    '/schedule/unavailable-days/parse',
    {
      department_section_id: departmentSectionID,
      personnel_ids: personnelIDs,
      start_at: DateTime.fromJSDate(startAt).toISODate(),
      end_at: DateTime.fromJSDate(endAt).toISODate(),
      prompt,
      image_data_url: imageDataUrl ?? null,
      language: getStoredLanguage(),
    },
    { signal },
  );
  return {
    entries: response.data.entries.map((entry: any) => ({
      personnelID: entry.personnel_id,
      startAt: DateTime.fromISO(entry.start_at).toJSDate(),
      endAt: DateTime.fromISO(entry.end_at).toJSDate(),
      ptoSubtype: entry.pto_subtype,
    })),
    warnings: response.data.warnings,
  };
};
